import PropTypes from "prop-types";
import { formatCurrency, formatDate } from "../../utils/utils";
import DisputeStatusPill from "./DisputeStatusPill";
import "./DisputesTable.css";

const Amount = ({ value, currency, highlight }) => {
  if (value === null || value === undefined) return <span>-</span>;
  return (
    <span className={highlight ? "disputes-table-amount--highlight" : ""}>
      {formatCurrency(value, currency)}
    </span>
  );
};

Amount.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currency: PropTypes.string,
  highlight: PropTypes.bool,
};

const DisputesTable = ({ disputes, currency, onReview }) => {
  if (!disputes.length) {
    return <div className="disputes-table-empty">No disputes to display.</div>;
  }

  return (
    <div className="disputes-table-container">
      <table className="disputes-table">
        <thead>
          <tr>
            <th>Dispute Status</th>
            <th>Disputed Date</th>
            <th>HT Confirmation ID</th>
            <th>Client Confirmation ID</th>
            <th>Transacted Booking Amount at Dispute</th>
            <th>Client Agreed Booking Amount</th>
            <th>Disputed Booking Amount</th>
            <th>Current Transacted Booking Amount</th>
            <th>Platform Fee at Dispute</th>
            <th>Current Platform Fee</th>
          </tr>
        </thead>
        <tbody>
          {disputes.map((dispute) => {
            const rowCurrency = dispute.currency || currency;
            return (
              <tr
                key={dispute.id}
                className="disputes-table-row disputes-table-row--clickable"
                onClick={() => onReview(dispute)}
              >
                <td>
                  <DisputeStatusPill status={dispute.status} />
                </td>
                <td>{formatDate(dispute.disputedDate)}</td>
                <td>{dispute.htRoomConfirmationCode}</td>
                <td>{dispute.clientConfirmationId}</td>
                <td>
                  <Amount
                    value={dispute.transactedBookingAmountAtDispute}
                    currency={rowCurrency}
                  />
                </td>
                <td>
                  <Amount
                    value={dispute.clientAgreedBookingAmount}
                    currency={rowCurrency}
                  />
                </td>
                <td>
                  <Amount
                    value={dispute.disputedBookingAmount}
                    currency={rowCurrency}
                    highlight
                  />
                </td>
                <td>
                  <Amount
                    value={dispute.currentTransactedBookingAmount}
                    currency={rowCurrency}
                  />
                </td>
                <td>
                  <Amount
                    value={dispute.platformFeeAtDispute}
                    currency={rowCurrency}
                  />
                </td>
                <td>
                  <Amount
                    value={dispute.currentPlatformFee}
                    currency={rowCurrency}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

DisputesTable.propTypes = {
  disputes: PropTypes.arrayOf(PropTypes.object).isRequired,
  currency: PropTypes.string,
  onReview: PropTypes.func.isRequired,
};

export default DisputesTable;
